import React, { memo, useMemo } from "react";
// components
import { SpriteIconWeb } from "@swiggy-private/dls-web-icons/dist/SpriteIconWeb";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
// styles
import { Container, TimerSVGContainer } from "./styles";
// types
import { CouponTimer, SwiggySixesTickerTimer } from "@swiggy-private/core-types";
import { format, isEmpty } from "@swiggy-private/js-utils";
// constants
import {
    IPL_TIMER_PLACEHOLDER,
    MINUTES_SECONDS_TEXT,
    DEFAULT_IPL_TIMER_GRADIENT,
    IPL_TIMER_TAG_DATA_TEST_IDS as IDS,
} from "./constants";

export interface TimerProps {
    titleTimer?: CouponTimer;
    tickerTimerInMinSec?: SwiggySixesTickerTimer;
}

const Timer = ({ titleTimer, tickerTimerInMinSec }: TimerProps) => {
    const {
        text = "",
        backgroundColor = DEFAULT_IPL_TIMER_GRADIENT,
        textColor = "text_inverse_Highest_Emphasis",
    } = titleTimer || {};

    const timerText = useMemo(() => {
        if (!isEmpty(text) && text.includes(IPL_TIMER_PLACEHOLDER) && tickerTimerInMinSec?.enabled) {
            return text.replace(
                IPL_TIMER_PLACEHOLDER,
                format(MINUTES_SECONDS_TEXT, tickerTimerInMinSec?.minutes, tickerTimerInMinSec?.seconds),
            );
        }
        return null;
    }, [tickerTimerInMinSec?.enabled, tickerTimerInMinSec?.minutes, tickerTimerInMinSec?.seconds, text]);

    if (isEmpty(timerText) || !tickerTimerInMinSec?.enabled) {
        return null;
    }

    return (
        <Container data-testid={IDS.CONTAINER} backgroundColor={backgroundColor}>
            <TimerSVGContainer>
                <SpriteIconWeb iconName="clockFilled12" fillColor="text_inverse_Highest_Emphasis" />
            </TimerSVGContainer>
            <Text data-testid={IDS.TEXT} variant="V2.caption.neutral.medium" color={textColor}>
                {timerText}
            </Text>
        </Container>
    );
};

export default memo(Timer);
